import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["fields"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';
import { useDropzone } from 'react-dropzone';
import useForm from 'hooks/useForm';
import { setAlert } from 'actions/alerts';
import { playlistQueryKeys } from 'actions/playlists';
import { useUploadFile } from 'actions/file';
import { badgeQueryKeys } from 'actions/badges';
import charCountRenderer from 'utils/charCountRenderer';
import { TYPE_BADGE_IMAGE, ONE_MB } from 'utils/file';
import { STYLE_STICKER, STYLE_ROSE } from 'utils/image/styles';
import Box from 'components/Box';
import Panel from 'components/Panel';
import FormField, { DefaultFormFieldLayout } from 'components/FormField';
import RadioButtonOption from 'components/RadioButtonOption';
import InlineList from 'components/InlineList';
import TextInput from 'components/TextInput';
import FormStack from 'components/FormStack';
import Button from 'components/Button';
import Card from 'components/Card';
import Modal from 'components/Modal';
import ModalHeadline from 'components/ModalHeadline';
import StickyButtonPanel from 'components/StickyButtonPanel';
import BadgeImage from 'components/BadgeImage';
import Icon from 'components/Icon';
import TextLink from 'components/TextLink';
import Status from 'components/Status';
import DropIndicator from 'components/DropIndicator';
import CloseConfirmationModal from './CloseConfirmationModal';
import EditConfirmationModal from './EditConfirmationModal';
var MAX_TEXT_LENGTH = 90;
var BrowseLink = function BrowseLink(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TextLink, {
    as: "span"
  }, children));
};
function BadgeImageDetailsModal(_ref2) {
  var initialBadgeImage = _ref2.initialBadgeImage,
    onClose = _ref2.onClose,
    parentPlaylistId = _ref2.parentPlaylistId,
    onAfterUpload = _ref2.onAfterUpload;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    selectedFile = _useState2[0],
    setSelectedFile = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isCloseConfirmationModalOpen = _useState4[0],
    setCloseConfirmationModalOpen = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isEditConfirmationModalOpen = _useState6[0],
    setEditConfirmationModalOpen = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isLoading = _useState8[0],
    setIsLoading = _useState8[1];
  var _useForm = useForm({
      fields: {
        imageId: {
          getDefaultValue: function getDefaultValue() {
            return (initialBadgeImage === null || initialBadgeImage === void 0 ? void 0 : initialBadgeImage.imageId) || null;
          }
        },
        style: {
          getDefaultValue: function getDefaultValue() {
            return (initialBadgeImage === null || initialBadgeImage === void 0 ? void 0 : initialBadgeImage.style) || STYLE_STICKER;
          }
        },
        imageAlternativeText: {
          getDefaultValue: function getDefaultValue() {
            return (initialBadgeImage === null || initialBadgeImage === void 0 ? void 0 : initialBadgeImage.imageAlternativeText) || '';
          }
        }
      }
    }),
    fields = _useForm.fields,
    form = _objectWithoutProperties(_useForm, _excluded);
  var _useUploadFile = useUploadFile({
      onSetAlert: function onSetAlert(options) {
        return setAlert(_objectSpread({
          key: 'upload-badge',
          title: t('alert_badge_image_uploading')
        }, options));
      }
    }),
    uploadFile = _useUploadFile.uploadFile;
  var titleId = 'badge-editor-dialog-title';
  var isEditMode = !!initialBadgeImage;
  var modalTitle = isEditMode ? t('actions_edit_badge_image') : t('actions_add_badge_image');

  // for useDropzone
  var selectFile = useCallback(function (acceptedFiles) {
    setIsLoading(true);
    var _acceptedFiles = _slicedToArray(acceptedFiles, 1),
      selectedUploadFile = _acceptedFiles[0];
    var preview = URL.createObjectURL(selectedUploadFile);
    setSelectedFile({
      preview: preview,
      file: selectedUploadFile
    });
    fields.imageId.set(preview);
    setIsLoading(false);
  }, [fields.imageId, setIsLoading]);
  var rejectFile = useCallback(function (rejectedFiles) {
    if (rejectedFiles.length > 1) {
      setAlert({
        title: t('error_upload_only_single_file')
      });
      return;
    }
    if (rejectedFiles[0].size > 3 * ONE_MB) {
      setAlert({
        title: t('error_file_too_large', {
          maxFileSizeInMb: 3
        })
      });
      return;
    }
    if (!rejectedFiles[0].type.includes('svg') && !rejectedFiles[0].type.includes('png')) {
      setAlert({
        title: t('error_file_type_unsupported_badge_image')
      });
    } else {
      setAlert({
        title: "".concat(t('error_uploading_file'), " ").concat(rejectedFiles[0].name)
      });
    }
  }, [t]);
  var _useDropzone = useDropzone({
      multiple: false,
      accept: ['.png', '.svg'],
      maxSize: 3 * ONE_MB,
      // Maximum file size (in bytes)
      onDropAccepted: selectFile,
      onDropRejected: rejectFile
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    isDragActive = _useDropzone.isDragActive,
    isDragReject = _useDropzone.isDragReject;
  var hasImage = selectedFile || (initialBadgeImage === null || initialBadgeImage === void 0 ? void 0 : initialBadgeImage.pictureUrl);
  var badgeImageSrc = selectedFile ? selectedFile.preview : initialBadgeImage === null || initialBadgeImage === void 0 ? void 0 : initialBadgeImage.pictureUrl;
  var badgeImageData = {
    style: isEditMode ? fields.style.wasChanged ? fields.style.value : undefined : fields.style.value,
    imageAlternativeText: isEditMode ? fields.imageAlternativeText.wasChanged ? fields.imageAlternativeText.value : undefined : fields.imageAlternativeText.value
  };
  var uploadBadgeImageFile = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(badgeImageData) {
      var res, getBadgeImageFromCache;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            if (!selectedFile) {
              _context.next = 9;
              break;
            }
            _context.next = 4;
            return uploadFile({
              file: selectedFile.file,
              type: TYPE_BADGE_IMAGE,
              style: badgeImageData.style,
              alternativeText: badgeImageData.imageAlternativeText,
              // if no initialBadgeImage id provided, creates a new badge entry in image table
              referenceId: initialBadgeImage === null || initialBadgeImage === void 0 ? void 0 : initialBadgeImage.imageId
            });
          case 4:
            res = _context.sent;
            // When adding a new image, simply refresh the BadgeImagePicker modal when new image is uploaded
            if (!isEditMode) {
              queryClient.invalidateQueries(badgeQueryKeys.allBadgeImages);
              // Refresh playlists which might be using the badge image
              queryClient.invalidateQueries(playlistQueryKeys.allPlaylists);
              // Select new uploaded image in badge image picker modal
              if (onAfterUpload) {
                onAfterUpload(_objectSpread({
                  imageId: res.badgeImageId,
                  pictureUrl: badgeImageSrc
                }, badgeImageData));
              }
            }

            // When replacing a badge image file, do an optimistic update as we otherwise show the outdated image file
            // in the Badge Image Picker (or wherever custom badge images are being used), while the new file is still uploading etc.
            if (isEditMode) {
              queryClient.setQueriesData(badgeQueryKeys.allBadgeImages, function (data) {
                var _data$pages;
                // Check each page until we find the correct badgeImage and get the correct page index and index of the badge image within the pages array
                var imgIndex;
                var pageIndex;
                data === null || data === void 0 ? void 0 : (_data$pages = data.pages) === null || _data$pages === void 0 ? void 0 : _data$pages.every(function (_page, i) {
                  var cachedImageIndex = data === null || data === void 0 ? void 0 : data.pages[i].items.findIndex(function (badgeImg) {
                    return (badgeImg === null || badgeImg === void 0 ? void 0 : badgeImg.id) === (initialBadgeImage === null || initialBadgeImage === void 0 ? void 0 : initialBadgeImage.imageId);
                  });
                  if (cachedImageIndex > -1) {
                    imgIndex = cachedImageIndex;
                    pageIndex = i;
                    return false;
                  }
                  return true;
                });

                // Once the correct index of the image is found, use the correct indexes to update the cache of the query
                if (imgIndex > -1) {
                  // Set new cache value
                  var updatedCache = _objectSpread({}, data);
                  updatedCache.pages[pageIndex].items[imgIndex].pictureUrl = res.fileUrl;
                  updatedCache.pages[pageIndex].items[imgIndex].alternativeText = fields.imageAlternativeText.value;
                  updatedCache.pages[pageIndex].items[imgIndex].style = fields.style.value;
                  return updatedCache;
                } else {
                  return data;
                }
              });
            }

            // When replacing a badge image file which is being used in the currently opened playlist (through which the edit modal was accessed),
            // do an optimistic update as we otherwise show the outdated image file for the playlist
            getBadgeImageFromCache = function getBadgeImageFromCache(data) {
              var _data$badge;
              // Set new cache value
              if ((data === null || data === void 0 ? void 0 : (_data$badge = data.badge) === null || _data$badge === void 0 ? void 0 : _data$badge.imageId) === (initialBadgeImage === null || initialBadgeImage === void 0 ? void 0 : initialBadgeImage.imageId)) {
                var updatedCache = _objectSpread({}, data);
                updatedCache.badge.pictureUrl = res.fileUrl;
                updatedCache.badge.imageAlternativeText = fields.imageAlternativeText.value;
                updatedCache.badge.style = fields.style.value;
                return updatedCache;
              } else {
                return data;
              }
            };
            if (isEditMode && parentPlaylistId) {
              queryClient.setQueryData(playlistQueryKeys.singlePlaylistDetails(parentPlaylistId), getBadgeImageFromCache);
              queryClient.setQueryData(playlistQueryKeys.mySinglePlaylistDetails(parentPlaylistId), getBadgeImageFromCache);
            }
          case 9:
            _context.next = 14;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            setAlert({
              title: t('error_uploading_file'),
              type: 'fail'
            });
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 11]]);
    }));
    return function uploadBadgeImageFile(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleSubmit = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            e.preventDefault();
            e.stopPropagation();

            // Upload a new badge image
            if (!(selectedFile && !isEditMode)) {
              _context2.next = 10;
              break;
            }
            setIsLoading(true);
            _context2.next = 6;
            return uploadBadgeImageFile(badgeImageData);
          case 6:
            setIsLoading(false);
            onClose();
            _context2.next = 11;
            break;
          case 10:
            if (isEditMode) {
              setEditConfirmationModalOpen(true);
              setIsLoading(false);
            }
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleSubmit(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleClose = function handleClose() {
    if (form.wasChanged) {
      setCloseConfirmationModalOpen(true);
    } else {
      onClose();
    }
  };
  function onChangeBadgeStyle(e) {
    var value = e.currentTarget.value;
    return fields.style.set(value);
  }
  var isSubmitDisabled = isEditMode ? !form.wasChanged : !(fields.imageAlternativeText.value.length && fields.imageId.value);
  var isEditConfirmationOpen = isEditConfirmationModalOpen && initialBadgeImage;
  return /*#__PURE__*/React.createElement(Modal, {
    width: "wide",
    "aria-labelledby": titleId,
    onRequestClose: handleClose,
    id: "badge-image-details-modal"
  }, /*#__PURE__*/React.createElement(Card, {
    as: "form",
    variant: "raised"
    // visible overflow is needed for the sticky footer panel
    ,
    overflow: "visible",
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(ModalHeadline, {
    sticky: true,
    title: modalTitle,
    titleId: titleId,
    onClose: handleClose
  }), /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(DefaultFormFieldLayout, {
    horizontal: false
  }, /*#__PURE__*/React.createElement(FormStack, null, /*#__PURE__*/React.createElement(FormField, {
    required: true,
    id: "badge-image",
    label: "".concat(t('file_type_image'), " *"),
    description: "".concat(t('form_badge_image_hint'), " ").concat(t('form_cover_image_hint', {
      size: '200x200'
    }))
  }, /*#__PURE__*/React.createElement("div", getRootProps(), /*#__PURE__*/React.createElement("input", getInputProps()), /*#__PURE__*/React.createElement(DropIndicator, {
    p: "m",
    textAlign: "center",
    background: "shaded",
    id: "file-drop-zone",
    isDragActive: isDragActive,
    isDragReject: isDragReject
  }, !hasImage && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    name: "upload",
    scale: 4
  }), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: "modal_upload_badge_image_message"
  }, "Drop an image file or", /*#__PURE__*/React.createElement(BrowseLink, null, "browse"), ' ', "to upload"))), hasImage && badgeImageSrc && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BadgeImage, {
    src: badgeImageSrc
  }), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: "modal_replace_badge_image_message"
  }, "Drop an image file or", /*#__PURE__*/React.createElement(BrowseLink, null, "browse"), ' ', "to replace this image")))))), /*#__PURE__*/React.createElement(FormField, {
    id: "badge-style",
    label: t('form_style')
  }, /*#__PURE__*/React.createElement(InlineList, {
    spacing: "m"
  }, /*#__PURE__*/React.createElement(RadioButtonOption, {
    id: "badge-style-sticker",
    onChange: onChangeBadgeStyle,
    checked: fields.style.value === STYLE_STICKER,
    value: STYLE_STICKER,
    label: /*#__PURE__*/React.createElement(React.Fragment, null, hasImage && badgeImageSrc && /*#__PURE__*/React.createElement(Box, {
      as: "span",
      mr: "xs"
    }, /*#__PURE__*/React.createElement(BadgeImage, {
      variant: STYLE_STICKER,
      src: badgeImageSrc
    })), t('form_badge_style_sticker'))
  }), /*#__PURE__*/React.createElement(RadioButtonOption, {
    checked: STYLE_ROSE === fields.style.value,
    value: STYLE_ROSE,
    id: "badge-style-rose",
    onChange: onChangeBadgeStyle,
    label: /*#__PURE__*/React.createElement(React.Fragment, null, hasImage && badgeImageSrc && /*#__PURE__*/React.createElement(Box, {
      as: "span",
      mr: "xs"
    }, /*#__PURE__*/React.createElement(BadgeImage, {
      variant: STYLE_ROSE,
      src: badgeImageSrc
    })), t('form_badge_style_rose'))
  }))), /*#__PURE__*/React.createElement(FormField, {
    required: true,
    label: "".concat(t('form_alternative_text'), " *"),
    description: t('form_badge_alternative_text_info'),
    shortHint: /*#__PURE__*/React.createElement(Status, null, charCountRenderer(fields.imageAlternativeText.value, MAX_TEXT_LENGTH))
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: fields.imageAlternativeText.value,
    maxLength: MAX_TEXT_LENGTH,
    onChange: function onChange(e) {
      return fields.imageAlternativeText.set(e.target.value);
    }
  }))))), /*#__PURE__*/React.createElement(StickyButtonPanel, null, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "primary",
    isLoading: isLoading,
    isDisabled: isSubmitDisabled,
    icon: "ok"
  }, t('actions_save')))), isCloseConfirmationModalOpen && /*#__PURE__*/React.createElement(CloseConfirmationModal, {
    isEditMode: isEditMode,
    onClose: function onClose() {
      return setCloseConfirmationModalOpen(false);
    },
    onConfirm: onClose
  }), isEditConfirmationOpen && /*#__PURE__*/React.createElement(EditConfirmationModal, {
    imageId: initialBadgeImage === null || initialBadgeImage === void 0 ? void 0 : initialBadgeImage.imageId,
    selectedFile: selectedFile,
    badgeImageData: badgeImageData,
    onConfirm: onClose,
    onClose: function onClose() {
      return setEditConfirmationModalOpen(false);
    },
    onUpload: uploadBadgeImageFile,
    parentPlaylistId: parentPlaylistId
  }));
}
export default BadgeImageDetailsModal;